import { useState } from "react";
import { showToast } from "../../components/ToastNotification";
import MatchGoalsModal from "./goalsMatchs/MatchGoalsModal";
import MatchCardsModal from "./cardsMatchs/MatchCardsModal";

const MatchStatusModal = ({ match, onClose, onSave, selectedSubcategory }) => {
  const [status, setStatus] = useState(match.status || "scheduled");
  const [scores, setScores] = useState({
    score_team1: match.score_team1 || "",
    score_team2: match.score_team2 || "",
  });
  const [showGoalsModal, setShowGoalsModal] = useState(false);
  const [showCardsModal, setShowCardsModal] = useState(false);
  const [matchDate, setMatchDate] = useState(
    match.match_date
      ? match.match_date.slice(0, 16)
      : new Date().toISOString().slice(0, 16),
  );

  const team1Info = match.team1_info || {};
  const team2Info = match.team2_info || {};

  const team1Name = team1Info.team_name || match.team1_name || "Equipo Local";
  const team2Name =
    team2Info.team_name || match.team2_name || "Equipo Visitante";

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      (status === "completed" || status === "in_progress") &&
      (scores.score_team1 === "" || scores.score_team2 === "")
    ) {
      showToast.error(
        "Debes ingresar los puntajes para este estado del partido",
      );
      return;
    }

    const finalScores =
      status === "completed" || status === "in_progress"
        ? scores
        : { score_team1: null, score_team2: null };

    onSave({
      ...match,
      status,
      match_date: matchDate
        ? new Date(matchDate).toISOString()
        : match.match_date,
      ...finalScores,
    });
  };

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        {/* Modal */}
        <div className="bg-white p-6 rounded-2xl shadow-2xl w-full max-w-md animate-fadeIn">
          <h2 className="text-xl font-bold mb-4 text-gray-800">
            Editar Partido
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Fecha */}
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">
                Fecha del Partido
              </label>
              <input
                type="datetime-local"
                value={matchDate}
                onChange={(e) => setMatchDate(e.target.value)}
                className="w-full p-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-900 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                required
              />
            </div>

            {/* Estado */}
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">
                Estado
              </label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="w-full p-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-900 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
              >
                <option value="scheduled">Por definirse</option>
                <option value="in_progress">En juego</option>
                <option value="completed">Finalizado</option>
              </select>
            </div>

            {/* Puntajes */}
            {(status === "completed" || status === "in_progress") && (
              <>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium mb-1 text-gray-700">
                      Puntaje {team1Name}
                      {/* Mostrar categoría si existe y no es 0 */}
                      {team1Info.category && team1Info.category !== 0 && (
                        <span className="ml-2 text-sm text-gray-400">
                          ({team1Info.category})
                        </span>
                      )}
                      {/* Mostrar grupo si existe */}
                      {team1Info.group_name && (
                        <span className="ml-2 text-sm text-gray-400">
                          - {team1Info.group_name}
                        </span>
                      )}
                    </label>
                    <input
                      type="number"
                      min="0"
                      value={scores.score_team1}
                      onChange={(e) =>
                        setScores({
                          ...scores,
                          score_team1: parseInt(e.target.value) || 0,
                        })
                      }
                      className="w-full p-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-900 focus:ring-2 focus:ring-emerald-500"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1 text-gray-700">
                      Puntaje {team2Name}
                      {/* Mostrar categoría si existe y no es 0 */}
                      {team2Info.category && team2Info.category !== 0 && (
                        <span className="ml-2 text-sm text-gray-400">
                          ({team2Info.category})
                        </span>
                      )}
                      {/* Mostrar grupo si existe */}
                      {team2Info.group_name && (
                        <span className="ml-2 text-sm text-gray-400">
                          - {team2Info.group_name}
                        </span>
                      )}
                    </label>
                    <input
                      type="number"
                      min="0"
                      value={scores.score_team2}
                      onChange={(e) =>
                        setScores({
                          ...scores,
                          score_team2: parseInt(e.target.value) || 0,
                        })
                      }
                      className="w-full p-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-900 focus:ring-2 focus:ring-emerald-500"
                      required
                    />
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => setShowGoalsModal(true)}
                  className="w-full mt-3 px-4 py-2 bg-purple-100 text-purple-700 rounded-lg hover:bg-purple-200 transition"
                >
                  Gestionar Goles
                </button>
              </>
            )}

            {(status === "completed" || status === "in_progress") && (
              <>
                {/* botón tarjetas */}
                <button
                  type="button"
                  onClick={() => setShowCardsModal(true)}
                  className="w-full mt-3 px-4 py-2 bg-yellow-100 text-yellow-700 rounded-lg hover:bg-yellow-200 transition"
                >
                  Gestionar Tarjetas
                </button>
              </>
            )}

            {/* Botones */}
            <div className="flex justify-end space-x-3 pt-2">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 shadow"
              >
                Guardar Cambios
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Submodal de goles */}
      {showGoalsModal && (
        <MatchGoalsModal
          match={match}
          selectedSubcategory={selectedSubcategory}
          onClose={() => setShowGoalsModal(false)}
        />
      )}
      {showCardsModal && (
        <MatchCardsModal
          match={match}
          selectedSubcategory={selectedSubcategory}
          onClose={() => setShowCardsModal(false)}
        />
      )}
    </>
  );
};

export default MatchStatusModal;
